import { render, staticRenderFns } from "./CardLivenessDossie.vue?vue&type=template&id=0aa98982&scoped=true"
import script from "./CardLivenessDossie.vue?vue&type=script&lang=js"
export * from "./CardLivenessDossie.vue?vue&type=script&lang=js"
import style0 from "./CardLivenessDossie.vue?vue&type=style&index=0&id=0aa98982&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa98982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa98982')) {
      api.createRecord('0aa98982', component.options)
    } else {
      api.reload('0aa98982', component.options)
    }
    module.hot.accept("./CardLivenessDossie.vue?vue&type=template&id=0aa98982&scoped=true", function () {
      api.rerender('0aa98982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LivenessHiveDetail/components/CardLivenessDossie.vue"
export default component.exports